<!-- @format -->
@if (!filtersOpen && isMobile && (!sameDayDeliveryEnabled() || selectedOptions.length > 0)) {
	<div
		class="store-info hmf-align-content-center"
		[ngClass]="{
			'hmf-display-none': selectedOptions.length === 0,
			'hmf-ml-xxl hmf-ml-lg-0': selectedOptions.length > 0 && (userZipCode() || userStoreInfo())
		}">
		<div class="hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-my-sm-0 hmf-my-xxxs hmf-px-s hmf-py-0 hmf-py-sm-xxxs store-info-mobile">
			<div class="hmf-label-xs hmf-text-transform-uppercase store-text">
				{{ locationLabel }}
			</div>
			<button
				hmf-action-text
				class="hmf-pt-xxxs hmf-px-0 store-name hmf-subheader-bold-m"
				[attr.aria-label]="mobileStoreName"
				[style.max-width]="selectedFilterCount === 0 ? '45vw' : '52vw'"
				(keydown.enter)="selectUserZipCodeAndStoreInfo()"
				(click)="selectUserZipCodeAndStoreInfo()">
				{{ mobileStoreName | titlecase }}
			</button>
		</div>
	</div>
}
<div
		class="shipping-options-container hide-scroll-bar hmf-py-xxs hmf-mb-m-0 hmf-p-m-xss hmf-body-bold-m hmf-display-flex hmf-align-items-flex-end">
		@if(!exposedFiltersEnabled()) {
			<div
				class="hmf-display-m-flex"
				[ngClass]="{ 'ship-container': !sameDayDeliveryEnabled() }">
				@if (!isMobile) {
					<span
						class="hmf-subheader-bold-m hmf-my-m-xs hmf-mt-l-xs shipping-option-label">
						SHIPPING
					</span>
				}
			</div>
		}
		<div
			class="pickup-shipping-container hmf-display-flex hmf-justify-content-between hmf-align-items-center hmf-pl-xs hmf-pl-lg-xxs"
			[class.hmf-flex-m-wrap]="!exposedFiltersEnabled()">
			@if (!isMobile && selectedOptions.includes('SHIP')) {
				<div
					class="hmf-display-flex hmf-flex-column hmf-mr-xxs hmf-ml-m-0 hmf-ml-s">
					<span class="hmf-text-transform-uppercase hmf-label-xs hmf-ml-xxs store-text">
						Ship To
					</span>
					<button
						hmf-action-text
						variant="secondary"
						class="hmf-pt-0 hmf-px-0 hmf-ml-xxs store-info-desktop store-info-btn"
						(click)="openZipCodePanel()">
						{{ userZipCode() || 'Update Delivery Location' | titlecase }}
					</button>
				</div>
			}
			@if (!isMobile && selectedOptions.includes('BOPIS')) {
				<div
					id="store-info"
					class="hmf-ml-m-0 hmf-ml-s store-info hmf-body-m">
					<div class="hmf-display-flex hmf-flex-column hmf-mr-xxs">
						<div
							class="hmf-text-transform-uppercase hmf-label-xs hmf-ml-xxs store-text hmf-label-xs">
							Pickup At
						</div>
						<button hmf-action-text
								variant="secondary"
								class="hmf-pt-0 hmf-px-0 hmf-ml-xxs store-info-desktop"
								(click)="openStorePanel()">
							{{ userStoreInfo()?.name || 'Select Store' | titlecase }}
						</button>
					</div>
				</div>
			}
			@if (!isMobile && selectedOptions.includes('SDD')) {
				<div
					class="hmf-display-flex hmf-flex-column hmf-mr-xxs hmf-ml-m-0 hmf-ml-s">
					<span class="hmf-text-transform-uppercase hmf-label-xs hmf-ml-xxs store-text">
						Deliver To
					</span>
					<button hmf-action-text
							variant="secondary"
							class="hmf-pt-0 hmf-px-0 hmf-ml-xxs store-info-desktop store-info-btn"
							(click)="openZipCodePanel()">
						{{ userZipCode() || 'Update Delivery Location' | titlecase }}
					</button>
				</div>
			}
			@if (!isMobile && selectedOptions.includes('ISA')) {
				<div
					class="hmf-display-flex hmf-flex-column hmf-mr-xxs hmf-ml-m-0 hmf-ml-s">
					<span class="hmf-text-transform-uppercase hmf-label-xs hmf-ml-xxs store-text">
						My Store
					</span>
					<button hmf-action-text
							variant="secondary"
							class="hmf-pt-0 hmf-px-0 hmf-ml-xxs store-info-desktop store-info-btn"
							(click)="openStorePanel()">
						{{ userStoreInfo()?.name || 'Select Store' | titlecase }}
					</button>
				</div>

			}
			<div
				class="options hmf-display-flex hmf-justify-content-between hmf-px-lg-xxxs hmf-pr-xxxs hmf-align-items-m-flex-end shipping-options hide-scroll-bar">
				@for (option of shippingOptionsKeys; track trackByFn($index, option)) {
					<plp-components-shipping-option-button
						[shippingOption]="shippingOptions[option]"
						[selected]="selectedOptions.includes(option)"
						[disabled]="disabled"
						[showCount]="showFulfillmentCount()"
						[count]="fulfillmentFacets()[option] ?? 0"
						(selectedOption)="setSelectedFilter(option)"
					></plp-components-shipping-option-button>
				}
			</div>
		</div>
</div>
